import { useContext } from 'react';
import { SupportModalToggleContext, SupportModalToggleContextType } from '#baseSupportModal/contexts';

const useSupportModalToggleContext = () => useContext<SupportModalToggleContextType>(SupportModalToggleContext);

export { useSupportModalToggleContext };
